import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import flameAnimation from "../json/FlameAnimation.json";
import SettingsPanel from "components/SettingsPanel";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import { useEffect, useState } from "react";
import {
  HiOutlineHome,
  HiOutlineShoppingBag,
  HiOutlineFire,
  HiOutlineCog6Tooth,
} from "react-icons/hi2";
import {
  CART_STORAGE_KEY,
  CART_UPDATED_EVENT,
  getCartItemCount,
} from "utils/cartStorage";

const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [cartItemCount, setCartItemCount] = useState(0);
  const { theme, language } = useSettings();
  const isDark = theme === "dark";

  useEffect(() => {
    const updateCartItemCount = () => {
      setCartItemCount(getCartItemCount());
    };

    const handleStorage = (event) => {
      if (event.key === CART_STORAGE_KEY) {
        updateCartItemCount();
      }
    };

    updateCartItemCount();
    window.addEventListener(CART_UPDATED_EVENT, updateCartItemCount);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(CART_UPDATED_EVENT, updateCartItemCount);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  const tabs = [
    { path: "/", label: t("home", language), icon: <HiOutlineHome size={22} />, },
    { path: "/cart", label: t("cart", language), icon: <HiOutlineShoppingBag size={22} />, },
    { path: "/hotOffer", label: t("offer", language), icon: <HiOutlineFire size={22} />,
    },
  ];

  return (
    <>
      <div
        className={`fixed bottom-0 left-0 right-0 z-50 border-t md:hidden transition-colors duration-300
                ${isDark ? "bg-gray-900 border-gray-700" : "bg-white border-gray-200"}`}
      >
        <div className="flex justify-around items-center h-14 w-full max-w-full overflow-hidden">
          {tabs.map((tab) => {
            const isActive = pathname === tab.path;

            return (
              <Link
                key={tab.path}
                to={tab.path}
                className="relative flex flex-col items-center text-xs shrink-0"
              >
                {/* Active bubble */}
                {isActive && (
                  <motion.span
                    layoutId="activeTab"
                    className="absolute"
                    transition={{ type: "spring", stiffness: 400, damping: 30 }}
                  />
                )}

                <div
                  className={`relative z-10 ${
                    isActive ? "text-red-500" : "text-gray-500"
                  }`}
                >
                  {tab.icon}
                  {tab.path === "/cart" && cartItemCount > 0 && (
                    <span className="absolute -right-2 -top-2 min-w-4 h-4 px-1 rounded-full bg-red-600 text-white text-[10px] font-bold leading-4 text-center">
                      {cartItemCount > 99 ? "99+" : cartItemCount}
                    </span>
                  )}
                </div>

                <span
                  className={`relative z-10 ${
                    isActive ? "text-red-500" : "text-gray-500"
                  }`}
                >
                  {tab.label}
                </span>
              </Link>
            );
          })}
          <button
            onClick={() => setIsSettingsOpen(true)}
            className="relative flex flex-col items-center text-xs shrink-0"
            aria-label="Open settings"
          >
            <HiOutlineCog6Tooth
               size={22}
               className={isDark ? "text-gray-400" : "text-gray-500"}
             />
             <span
               className={`relative z-10 ${
                 isDark ? "text-gray-400" : "text-gray-500"
               }`}
             >
               {t("settings", language)}
             </span>
          </button>
        </div>
      </div>
      <SettingsPanel
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
      />
    </>
  );
};

export default MobileBottomNav;
